import React,{useContext} from "react";
import FetchingFreq from '../../contexts/FetchingFreq';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { 
  faFolder, 
  faFile,
  faTable, 
  faChartBar,
  faArrowLeft,
  faGear,
  faDownload,
  faGauge,
  faBuilding,
  faWeightScale,
  faPeopleRoof,faUpload,
  faHouse,
  faLaptopFile,
  faChargingStation,
  faEdit,
  faSearch,
  faFilter,
  faSave,
  faRefresh,
  faExclamationTriangle,
  faFileExcel,
  faChevronDown,faCheckCircle
} from '@fortawesome/free-solid-svg-icons';

const SpssPage = ({handleQuestionLogicChange,handleExportSpssSyntax,handleExportDimensionSyntax,handleSaveScriptingLogic}) => {
      const {
        setMessage, 
        setActivePage,
        handleTitleClick,
        selectedTitle, 
        setSelectedTitle,
        refreshData, 
        setRefreshData,
        selectedBanner, 
        setselectedBanner,
        selectedWeights, 
        setSelectedWeights,
        selectedVariable, 
        setSelectedVariable,
        loading, 
        setLoading,
        validationData, 
        setValidationData,
        handleDVValidation ,
        activeTab, setActiveTab
    } = useContext(FetchingFreq);

const renderValueLabelsSummary = (valueLabels) => {
        if (!valueLabels || Object.keys(valueLabels).length === 0) {
            return <p>No value labels available.</p>;
        }
        return (
            <ul className="value-labels-list">
                {Object.entries(valueLabels)
                    .sort(([a], [b]) => parseFloat(a) - parseFloat(b))
                    .map(([code, label]) => (
                        <li key={code}>
                            <strong>{parseFloat(code)}:</strong> {label}
                        </li>
                    ))}
            </ul>
        );
    };
    const getMissingIndicatorClass = (hasMissing) => {
        if (hasMissing === true) return 'missing-indicator missing-yes';
        if (hasMissing === false) return 'missing-indicator missing-no';
        return 'missing-indicator missing-error';
    };

    const getMissingText = (hasMissing, error) => {
        if (hasMissing === true) return 'Yes';
        if (hasMissing === false) return 'No';
        return error || '—';
    };


  return (
    <div className="spss-content">
                    {selectedVariable && (
                        <div className="question-info-card">
                            <h4 className="question-info-header">Question Information</h4>
                            <div className="question-info-grid">
                                <strong>Label:</strong>
                                <span>{selectedVariable.Qtitle}</span>
                                
                                <strong>Type:</strong>
                                <span>{selectedVariable.type}</span>
                                
                                {selectedVariable.valueLabels && (
                                    <>
                                        <strong>Value Labels:</strong>
                                        <div>
                                            {renderValueLabelsSummary(selectedVariable.valueLabels)}
                                            {validationData && Object.keys(validationData).length > 0 && (
                                                <div className="mention-summary">
                                                    <strong>Min mentions: {validationData['__mention_summary__'].min_mentions}</strong>
                                                    {' | '}
                                                    <strong>Max mentions: {validationData['__mention_summary__'].max_mentions}</strong>
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    )}

                    {validationData && Object.keys(validationData).length > 0 && (
                        <div className="validation-table-container">
                            <table className="validation-table">
                                <thead>
                                    <tr>
                                        <th className="variable">Variable</th>
                                        <th className="unique-codes">Unique Codes</th>
                                        <th className="has-missing">Has Missing?</th>
                                        <th className="var-logic">Var Logic</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(validationData).map(([varName, info]) => (
                                        <tr key={varName}>
                                            <td>{varName}</td>
                                            <td>
                                                {info.unique_codes ? info.unique_codes.join(', ') : '—'}
                                            </td>
                                            <td>
                                                <span className={getMissingIndicatorClass(info.has_missing)}>
                                                    {getMissingText(info.has_missing, info.error)}
                                                </span>
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    placeholder="e.g. Q1 == 1 and Q3 != 5"
                                                    value={selectedVariable?.Logic || ''}
                                                    onChange={(e) => handleQuestionLogicChange(e.target.value)}
                                                    className="filter-logic-input"
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    <div className="filter-logic-section">
                        <h4 className="filter-logic-header">Custom Filter Logic</h4>
                        <input
                            type="text"
                            placeholder="e.g. Q1 == 1 and Q3 != 5"
                            value={selectedVariable?.Logic || ''}
                            onChange={(e) => handleQuestionLogicChange(e.target.value)}
                            className="filter-logic-input"
                        />
                    </div>

                    {/* Export Buttons Section */}
                    <div className="export-section">
                        <button
                            className="export-button spss-button"
                            onClick={handleExportSpssSyntax}
                            disabled={loading}
                        >
                            <FontAwesomeIcon icon={faDownload} />
                            Export SPSS Syntax (.sps)
                        </button>

                        <button
                            className="export-button dimension-button"
                            onClick={handleExportDimensionSyntax}
                            disabled={loading}
                        >
                            <FontAwesomeIcon icon={faDownload} />
                            Export Dimension Syntax (.mrs)
                        </button>


                        <button
                            className="save-button"
                            onClick={handleSaveScriptingLogic}
                        >
                            Save All Settings
                        </button>
                    </div>
                </div>
  );
};

export default SpssPage;
